module.exports = __webpack_public_path__ + "static/media/veggieSticks.b7a9a722.png";